import { render, staticRenderFns } from "./ChargeWalletFactor.vue?vue&type=template&id=1b3d0444"
import script from "./ChargeWalletFactor.vue?vue&type=script&lang=js"
export * from "./ChargeWalletFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports